// extracted by mini-css-extract-plugin
export default {"banner":"MicrositePlanBanner_banner__wP3O1"};